export enum ETransactionStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  Complaint = 'Complaint',
}
